import { render, staticRenderFns } from "./receiptedGoodsDetail.vue?vue&type=template&id=1d4fef2a&scoped=true&"
import script from "./receiptedGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./receiptedGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./receiptedGoodsDetail.vue?vue&type=style&index=0&id=1d4fef2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4fef2a",
  null
  
)

export default component.exports